// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__xjQgA","title":"ClientReferral_title__zfyxz","itemText":"ClientReferral_itemText__cHOP6"};